import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'semantic-ui-react';
import { MfaStatusType } from '@upstart/harmony/lib/legos/constants/user';
import validation from '@upstart/harmony/lib/validation';
import AuthService from '../../services/AuthService';
import ErrorMessage from '../ErrorMessage';
import './AuthForm.scss';

export default class AuthForm extends PureComponent {
  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
      oktaRequired: false,
    };
  }

  onChange = field => async event => {
    this.setState({
      [field]: event.target.value,
    });

    if (field === 'email') {
      const email = event.target.value.trim();

      if (!validation.isEmail(email)) {
        this.setState({ oktaRequired: false });
        return;
      }

      const { oidcRequired: oktaRequired } = await AuthService.oktaRequired({
        email,
      });

      this.setState({ oktaRequired });
    }
  };

  onSubmit = () => {
    const { email, password } = this.state;
    if (this.authWithOkta) {
      this.props.onOktaSubmit(email);
    } else {
      this.props.onSubmit({ email, password });
    }
  };

  get authWithOkta() {
    return (
      this.state.oktaRequired ||
      this.props.error?.status === MfaStatusType.OIDC_REQUIRED
    );
  }

  render() {
    const { error, fetching, didResetPwd } = this.props;

    return (
      <>
        {didResetPwd && <p className="authform-resetPwd">Password updated!</p>}
        <Form error={!!error} loading={fetching} onSubmit={this.onSubmit}>
          {error && <ErrorMessage error={error} />}
          <Form.Field>
            <label>Email</label>
            <input
              type="email"
              value={this.state.email}
              onChange={this.onChange('email')}
              onBlur={this.onBlur}
              placeholder="Email..."
              required
              data-dd-privacy="mask"
              className="amp-mask"
            />
          </Form.Field>
          {!this.authWithOkta && (
            <Form.Field>
              <label>Password</label>
              <input
                value={this.state.password}
                onChange={this.onChange('password')}
                type="password"
                placeholder="Password..."
                required
              />
            </Form.Field>
          )}
          <Button color="blue" type="submit">
            Sign In
          </Button>
        </Form>
      </>
    );
  }
}

AuthForm.propTypes = {
  error: PropTypes.object,
  fetching: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  didResetPwd: PropTypes.bool,
  onOktaSubmit: PropTypes.func.isRequired,
};
